import { render, staticRenderFns } from "./business-heading.vue?vue&type=template&id=7abf8ae9&scoped=true&"
import script from "./business-heading.vue?vue&type=script&lang=js&"
export * from "./business-heading.vue?vue&type=script&lang=js&"
import style0 from "./business-heading.vue?vue&type=style&index=0&id=7abf8ae9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abf8ae9",
  null
  
)

export default component.exports